import { render, staticRenderFns } from "./ScriveEditTemplate.vue?vue&type=template&id=0a4de58c&scoped=true&"
import script from "./ScriveEditTemplate.vue?vue&type=script&lang=ts&"
export * from "./ScriveEditTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ScriveEditTemplate.vue?vue&type=style&index=0&id=0a4de58c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4de58c",
  null
  
)

export default component.exports